import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Api from '../views/Api.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },

  {
    path: '/api',
    name: 'api',
    component: Api
  },

  {
    path: '/registration',
    name: 'registration',
    components: {
      default : () => import(/* webpackChunkName: "au" */ '../views/Registration.vue'),
    },
  },

  {
    path: '/confirmemail',
    name: 'confirmemail',
    component: () => import(/* webpackChunkName: "au" */ '../views/ConfirmEmail.vue')
  },

  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "au" */ '../views/Privacy.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "au" */ '../../../assistant/src/views/Terms.vue')
  },
  {
    path: '/invite',
    name: 'docInvite',
    component: () => import(/* webpackChunkName: "au" */ '../views/DocInvite.vue'),
  },

  {
    path: '/logs',
    name: 'logs',
    component: () => import(/* webpackChunkName: "au" */ '../views/Logs.vue')
  },
  {
    path: '/authorizationwz',
    name: 'authorizationwz',
    components: {
      default : () => import(/* webpackChunkName: "au" */ '../views/AuthorizationWz.vue'),
    },

  },
  {
    path: '/getApp',
    name: 'getApp',
    components: {
      default : () => import(/* webpackChunkName: "au" */ '../components/common/getApp/index.vue'),
    },

  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
